<template>
  <div class="rounded-[8px] bg-[#F0EFF3] py-[4px] relative px-[8px]">
    <div class="rounded-[8px] h-[7px]" :style="{width: percent+'%',backgroundColor: getColorByPercent(percent)}"></div>
    <div class="text-11 font-medium absolute top-0 pl-[10px]" :style="{left: percent+'%'}">{{ ratio }}</div>
  </div>
</template>
<script>
import MixinIAReputation from '@/mixins/iareputation.js'

export default {
  mixins: [MixinIAReputation],
  props: {
    percent: {
      default: 0,
    },
    ratio: {
      default: ''
    }
  }
}
</script>
<style>
.rounded-\[8px\]{
border-radius: 8px;
}
.bg-\[\#F0EFF3\]{
background-color: #F0EFF3;
}
.py-\[4px\]{
padding-top: 4px;
padding-bottom: 4px;
}
.h-\[7px\]{
height: 7px;
}
.px-\[8px\]{
  padding-left: 8px;
  padding-right: 8px;
}
.top-0{
  top: 0;
}
.pl-\[10px\]{
padding-left: 10px;
}
</style>
